<template>
  <section class="layout-pt-lg" :style="`background-color: var(--c-${vars.backgroundColor})`">
    <div class="container">
      <div class="row d-block d-md-none mb-30" :class="{ 'order-1': vars.isReversedBool }">
        <div class="col-12">
          <div class="tw-relative" style="position: relative">
            <NuxtImg
              v-if="vars.photoImage"
              :src="vars.photoImage"
              :style="{ borderRadius: 'var(--rounded)', overflow: 'hidden', position: 'relative', zIndex: 1 }"
            />
            <LibraryPopupsVideoPopup v-if="vars.photoImage" :videoUrl="vars.videoUrl" v-model:is-visible="isVisible" />
            <library-video-embed
              v-else-if="vars.videoUrl"
              :video-url="vars.videoUrl"
              title="Video Popup"
              :is-popup="true"
              :cover-photo="vars.photoImage || null"
              style="position: relative; z-index: 1"
            />
            <div
              v-if="vars.videoUrl && vars.isPopupBool"
              class="tw-absolute tw-left-1/2 tw-top-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2"
              style="z-index: 2"
            >
              <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M32 4C26.4621 4 21.0486 5.64217 16.444 8.71885C11.8395 11.7955 8.25064 16.1685 6.13139 21.2849C4.01213 26.4012 3.45764 32.0311 4.53802 37.4625C5.61841 42.894 8.28515 47.8831 12.201 51.799C16.1169 55.7149 21.106 58.3816 26.5375 59.462C31.969 60.5424 37.5988 59.9879 42.7151 57.8686C47.8315 55.7494 52.2045 52.1605 55.2812 47.556C58.3578 42.9514 60 37.5379 60 32C60 24.5739 57.05 17.452 51.799 12.201C46.548 6.94999 39.4261 4 32 4ZM46.894 33.79L22.894 45.79C22.589 45.9424 22.2501 46.0143 21.9095 45.9989C21.5689 45.9835 21.2379 45.8812 20.948 45.7019C20.658 45.5225 20.4187 45.272 20.2528 44.9741C20.0869 44.6763 19.9999 44.341 20 44V20C20.0002 19.6592 20.0875 19.3241 20.2535 19.0265C20.4196 18.729 20.6589 18.4787 20.9488 18.2996C21.2387 18.1205 21.5696 18.0184 21.91 18.0031C22.2505 17.9878 22.5892 18.0597 22.894 18.212L46.894 30.212C47.2258 30.3783 47.5047 30.6336 47.6997 30.9494C47.8946 31.2651 47.9979 31.6289 47.9979 32C47.9979 32.3711 47.8946 32.7349 47.6997 33.0507C47.5047 33.3664 47.2258 33.6217 46.894 33.788"
                  fill="white"
                />
              </svg>
            </div>

            <!-- Mobile gold borders -->
            <div
              :style="`position: absolute; top: 160px; bottom: 0; right: 0; width: 12px; background-color: var(--c-${vars.borderColor}); transform: translateX(6px); z-index: 0;`"
            ></div>
            <div
              :style="`position: absolute; left: 160px; right: -6px; bottom: 0; height: 12px; background-color: var(--c-${vars.borderColor}); transform: translateY(6px); z-index: 0;`"
            ></div>
          </div>
        </div>
      </div>

      <!-- Regular content row - original layout for desktop, modified for mobile -->
      <div class="row y-gap-30 justify-between items-center">
        <!-- Content Column -->
        <div class="col-xl-5" :class="{ 'order-md-1': vars.isReversedBool }">
          <div class="row y-gap-60 md:y-gap-30">
            <div v-html="vars.titleHtml"></div>
            <div v-for="(reason, index) in reasons" :key="reason.title" class="col-12">
              <div class="iconCard -type-3">
                <div class="iconCard__icon">
                  <nuxt-img :src="reason.icon" />
                </div>
                <div class="iconCard__content">
                  <h5 class="iconCard__title">{{ reason.title }}</h5>
                  <p class="iconCard__text">{{ reason.description }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop-only video container, hidden on mobile -->
        <div class="col-lg-6 d-none d-md-block tw-relative" :class="{ 'order-md-0': vars.isReversedBool }">
          <div class="tw-relative" style="position: relative">
            <!-- Original image/video element - now only shown on desktop -->
            <NuxtImg
              v-if="vars.photoImage"
              :src="vars.photoImage"
              :style="{ borderRadius: 'var(--rounded)', overflow: 'hidden', position: 'relative', zIndex: 1 }"
            />
            <LibraryPopupsVideoPopup v-if="vars.photoImage" :videoUrl="vars.videoUrl" v-model:is-visible="isVisible" />
            <library-video-embed
              v-else-if="vars.videoUrl"
              :video-url="vars.videoUrl"
              title="Video Popup"
              :is-popup="true"
              :cover-photo="vars.photoImage || null"
              style="position: relative; z-index: 1"
            />
            <div
              v-if="vars.videoUrl && vars.isPopupBool"
              class="tw-absolute tw-left-1/2 tw-top-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2"
              style="z-index: 2"
            >
              <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M32 4C26.4621 4 21.0486 5.64217 16.444 8.71885C11.8395 11.7955 8.25064 16.1685 6.13139 21.2849C4.01213 26.4012 3.45764 32.0311 4.53802 37.4625C5.61841 42.894 8.28515 47.8831 12.201 51.799C16.1169 55.7149 21.106 58.3816 26.5375 59.462C31.969 60.5424 37.5988 59.9879 42.7151 57.8686C47.8315 55.7494 52.2045 52.1605 55.2812 47.556C58.3578 42.9514 60 37.5379 60 32C60 24.5739 57.05 17.452 51.799 12.201C46.548 6.94999 39.4261 4 32 4ZM46.894 33.79L22.894 45.79C22.589 45.9424 22.2501 46.0143 21.9095 45.9989C21.5689 45.9835 21.2379 45.8812 20.948 45.7019C20.658 45.5225 20.4187 45.272 20.2528 44.9741C20.0869 44.6763 19.9999 44.341 20 44V20C20.0002 19.6592 20.0875 19.3241 20.2535 19.0265C20.4196 18.729 20.6589 18.4787 20.9488 18.2996C21.2387 18.1205 21.5696 18.0184 21.91 18.0031C22.2505 17.9878 22.5892 18.0597 22.894 18.212L46.894 30.212C47.2258 30.3783 47.5047 30.6336 47.6997 30.9494C47.8946 31.2651 47.9979 31.6289 47.9979 32C47.9979 32.3711 47.8946 32.7349 47.6997 33.0507C47.5047 33.3664 47.2258 33.6217 46.894 33.788"
                  fill="white"
                />
              </svg>
            </div>

            <!-- Gold border - right side -->
            <div
              :style="`position: absolute; top: 100px; bottom: 0; right: 0; width: 12px; background-color: var(--c-${vars.borderColor}); transform: translateX(6px); z-index: 0;`"
            ></div>

            <!-- Gold border - bottom side -->
            <div
              :style="`position: absolute; left: 100px; right: -6px; bottom: 0; height: 12px; background-color: var(--c-${vars.borderColor}); transform: translateY(6px); z-index: 0;`"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'WhyBox',

  mixins: [ComponentMixin],

  computed: {
    reasons() {
      return this.groupedVariables.reasons;
    },
  },
});
</script>

<style scoped lang="css">
.iconCard.-type-3 .iconCard__icon {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 100px;
  height: 100px;
  font-size: 40px;
  border-radius: 100%;
  border: none !important;
  margin-right: 20px;
}

@media (max-width: 575px) {
  .iconCard.-type-3 {
    flex-direction: row !important;
  }
}
</style>
